module.exports = __webpack_public_path__ + "6256b167a019af3d12827e5b4bc63fcf.svg";